import Fila from 'components/corporatiu/Fila';
import Boto from 'components/corporatiu/Boto';
import styles from './marcadormarato.module.scss';
import clsx from 'clsx';

const MarcadorMarato = (props) => {
    const { text = 'Marcador provisional:', total = '0 €', ocultar = false } = props;
    const stylesMarcador = clsx({
        [styles.marcadorMarato]: true,
        [styles.ocultar]: ocultar
    });
    return (
        <div className={stylesMarcador}>
            <Fila tipus='fixed'>
                <div className={styles.wrapper}>
                    {!ocultar && (
                        <div className={styles.marcador}>
                            <span className={styles.text}>{text}</span>
                            <span className={styles.quantitat}>{total}</span>
                        </div>
                    )}
                    <Boto
                        link='/tv3/marato/donatiu/'
                        className={styles.boto}
                        tema='maratoCTA'
                        text='Fes el teu donatiu'
                        icona='fletxa_simple_dreta'
                    />
                </div>
            </Fila>
        </div>
    );
};

export default MarcadorMarato;
